import { ButtonHTMLAttributes, ElementType, ReactNode } from "react";
import { twMerge } from 'tailwind-merge'

interface ElementProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: ElementType,
    text?: string,
    children?: ReactNode,
}

export function Outline({ icon: Icon, text, children, ...rest }: ElementProps) {
    return (
        <button
            type="button"
            {...rest}
            className={twMerge("tw-min-w-[200px] tw-max-w-[230px]  tw-pt-0.5 tw-font-medium tw-text-lg tw-text-[#ED636E] tw-border-2 tw-border-[#ED636E] tw-bg-white hover:tw-text-[#E13441] hover:tw-border-[#E13441] tw-rounded-lg", rest.className)}
        >
            {children}
            {Icon && <Icon />}
        </button>
    )
}